export default __webpack_public_path__ + "feb620fab1fe748f49d7103caf6c3b27.png";